import { useState } from 'react';

import endpoints from '../../../../../../api/endpoints';
import { DialogError } from '../../../../../common/business-error';
import { handleResponseError } from '../../../../../../api/handleResponseError';
import { fetchWithTokenRefresh } from '../../../../../../api/fetchWithTokenRefresh';

import { getCreditDetailsBusinessError } from '../businessErrors';
import { WalletCreditInfoResponse } from '../../add-funds-to-your-wallet/interfaces';

export const useShowCreditDetails = () => {
  const [creditDetails, setCreditDetails] = useState<WalletCreditInfoResponse | null>(null);
  const [creditDetailsLoading, setLoading] = useState<boolean>(false);
  const [creditDetailsError, setError] = useState<DialogError>(null);

  const handleCreditDetails = async (creditOrderId: string) => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetchWithTokenRefresh(endpoints.walletCreditInfo(creditOrderId));

      if (response.status !== 200) {
        await handleResponseError(response);
      }

      const jsonResponse = await response.json();

      setCreditDetails(jsonResponse);
      setLoading(false);
    } catch (e) {
      const { message, severity } = getCreditDetailsBusinessError(e);

      setError({ message, severity });
      setLoading(false);
    }
  };

  return {
    creditDetails,
    creditDetailsLoading,
    creditDetailsError,
    handleCreditDetails
  };
};
